import Tippy from "@tippyjs/react";
import { timeFormat } from "d3";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import "tippy.js/dist/tippy.css";
import { useSelector } from "../../../../../store/hooks";
import {
  ETimelineExtraDataLineSpecial,
  PremiumType,
} from "../../../../../types/types";

const formatter = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

const tickFormat = timeFormat("%d.%m.%Y");
export const currencyFormat = (num: number) => {
  if (!num && num !== 0) return;
  return formatter.format(num);
};

export const OneTimePremiumSegmentTooltip = ({ children, d }) => {
  const { t } = useTranslation();
  const taxonomy = useSelector((s) => s.taxonomy);
  const appSettings = useSelector((s) => s.timeline.timelineAppSettings);

  let period = (
    <>
      {tickFormat(d.startDate)}
      <br />
    </>
  );
  const total: number = d.extraData.associatedObjects
    .map((el) => el.oneTimePremiumGrossValue)
    .reduce((prev, current) => prev + current, 0);

  const getDomainValue = (domainValue, lineSpecial) => {
    if (
      domainValue === PremiumType.FLEETLEGAL_PRORATA &&
      lineSpecial === ETimelineExtraDataLineSpecial.CLOSING_DATE
    ) {
      return PremiumType.FLEETLEGAL_CLOSINGDATE;
    }
    if (
      domainValue === PremiumType.FLEETLEGAL_PRORATA &&
      lineSpecial !== ETimelineExtraDataLineSpecial.CLOSING_DATE
    ) {
      return PremiumType.FLEETLEGAL_PRORATA;
    }

    if (
      domainValue === PremiumType.HULL_ON_LAND_PRORATA &&
      lineSpecial === ETimelineExtraDataLineSpecial.CLOSING_DATE
    ) {
      return PremiumType.HULL_ON_LAND_CLOSINGDATE;
    }
    if (
      domainValue === PremiumType.HULL_ON_LAND_PRORATA &&
      lineSpecial !== ETimelineExtraDataLineSpecial.CLOSING_DATE
    ) {
      return PremiumType.HULL_ON_LAND_PRORATA;
    }

    if (
      domainValue === PremiumType.MACHINERY_BREAKDOWN_PRORATA &&
      lineSpecial === ETimelineExtraDataLineSpecial.CLOSING_DATE
    ) {
      return PremiumType.MACHINERY_BREAKDOWN_CLOSINGDATE;
    }
    if (
      domainValue === PremiumType.MACHINERY_BREAKDOWN_PRORATA &&
      lineSpecial !== ETimelineExtraDataLineSpecial.CLOSING_DATE
    ) {
      return PremiumType.MACHINERY_BREAKDOWN_PRORATA;
    }

    if (
      domainValue === PremiumType.HULL &&
      lineSpecial === ETimelineExtraDataLineSpecial.BASIC
    ) {
      return PremiumType.HULL_BASIC;
    }
    if (
      domainValue === PremiumType.HULL &&
      lineSpecial !== ETimelineExtraDataLineSpecial.BASIC
    ) {
      return PremiumType.HULL;
    }

    return domainValue;
  };
  return (
    <Tippy
      delay={100}
      followCursor={true}
      disabled={false}
      maxWidth={1000}
      content={
        <span>
          {t("bfm.oneTimePremium")}
          {" - "}

          {t(getDomainValue(d.domain.value, d.extraData.lineSpecial))}
          {/* {t(
            taxonomy.VehicleIssuingStatus.byId[
              d.associatedObject.vehicleIssuingStatusCode
            ]?.code
          )} */}
          <br />
          {period}
          <hr />
          {d.extraData.associatedObjects.map((associatedObject, index) => {
            return (
              <span
                key={`onetimepremium_${associatedObject.vehicleOneTimePremiumId}_${index}`}
              >
                <hr />
                {d.extraData.associatedObjects.length > 1 ? (
                  <span>
                    {t(
                      taxonomy.OneTimePremiumType.byId[
                        associatedObject.oneTimePremiumTypeCode
                      ].code
                    ).replace(/ /g, "\u00a0")}
                    {":\u00a0"}
                    {currencyFormat(associatedObject.oneTimePremiumGrossValue)}
                    &nbsp;
                    {appSettings?.CURRENCY_SYMBOL}
                    <br />
                  </span>
                ) : (
                  <span>
                    {t(
                      taxonomy.OneTimePremiumType.byId[
                        associatedObject.oneTimePremiumTypeCode
                      ].code
                    ).replace(/ /g, "\u00a0")}
                    {":\u00a0"}
                    {currencyFormat(associatedObject.oneTimePremiumGrossValue)}
                    &nbsp;
                    {appSettings?.CURRENCY_SYMBOL}
                    <br />
                  </span>
                )}
                {t("bfm.setByUserName.label")}:{" "}
                {associatedObject?.setByUserName}
                <br />
                {t("bfm.setAt.label")}:{" "}
                {tickFormat(moment(associatedObject?.setAt).toDate())}
                <br />
                {t("bfm.changeReasonComment.label")}:{" "}
                {associatedObject?.oneTimePremiumComment}
                <br />
              </span>
            );
          })}
          {d.extraData.associatedObjects.length > 1 ? (
            <>
              <hr />
              {t("bfm.total")}
              {":"}&nbsp;
              {currencyFormat(total)}
              &nbsp;{appSettings?.CURRENCY_SYMBOL}
            </>
          ) : null}
        </span>
      }
    >
      {children}
    </Tippy>
  );
};
